<div class="glossary-panel">
    <h2>Glossar</h2>

    <!-- Search -->
    <div class="glossary-search">
        <span class="p-input-icon-left w-full">
            <i class="pi pi-search"></i>
            <input type="text"
                   pInputText
                   [(ngModel)]="searchQuery"
                   (input)="onSearch()"
                   placeholder="Begriff suchen..."
                   class="w-full" />
        </span>
    </div>

    <!-- Alphabet Filter -->
    <div class="alphabet-filter">
        <span *ngFor="let letter of alphabet"
              class="letter"
              [class.active]="selectedLetter === letter"
              [class.disabled]="!hasTermsForLetter(letter)"
              (click)="hasTermsForLetter(letter) && onLetterClick(letter)">
            {{letter}}
        </span>
    </div>

    <!-- Loading -->
    <div *ngIf="isLoading" class="loading">
        <i class="pi pi-spin pi-spinner"></i> Glossar wird geladen...
    </div>

    <!-- Terms List -->
    <div *ngIf="!isLoading" class="terms-list">
        <div *ngFor="let term of filteredTerms" class="term-item">
            <div class="term-name">{{term.term}}</div>
            <div class="term-definition">{{term.definition}}</div>
        </div>

        <div *ngIf="filteredTerms.length === 0" class="no-terms">
            <p>Keine Begriffe gefunden.</p>
        </div>
    </div>
</div>
